export * from './image-upload-component-config.interface';
